import React, { useEffect, useState, useRef } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

import HomeScreen from './home';
function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const { change, getInitData} = useRefresh();
    const [showDetailProduct, setShowDetailProduct] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [showHome, setShowHome] = useState(false);
    const [menus, setMenus] = useState([]);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const touchStartX = useRef(null);
    const carouselImages = [
      
      
        require('./assets/carrousel/home3.jpeg'),
    ];
 const [valentine, setvalentine] = useState([]);
 const [datakarol, setdatakarol] = useState(false);
     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    
    useEffect(() => {
        const timer = setInterval(() => {
            setCarouselIndex(i => (i + 1) % carouselImages.length);
        }, 2000);
        return () => clearInterval(timer);
    }, [carouselImages.length]);

       useEffect(() => {

    }, [change]);



    useEffect(() => {
    if (valentine) {
      valentine.map((item) => {
       
          if (item.id === 5494) {
          setdatakarol(item);
          }
         
      });
    }
    }, [valentine]);
    

     useEffect(() => {
            console.log(goHomeInit, 'q mas qlq')
              setShowHome(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
           setShowHome(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };
    

    return (
        <LayoutContent  showBack={false} showFooter={false} showLogo={false} showImageTop={false} setShowSpecials={() => {

        }} goCategories={null}>
            <div>
                <div style={{ width: '100%', marginTop: -23}}>
                    <div
                        onClick={() => setShowHome(true)}
                        onTouchStart={e => { touchStartX.current = e.touches[0].clientX; }}
                        onTouchEnd={e => {
                            if (touchStartX.current === null) return;
                            const diff = touchStartX.current - e.changedTouches[0].clientX;
                            if (Math.abs(diff) > 40) {
                                setCarouselIndex(i => diff > 0
                                    ? (i + 1) % carouselImages.length
                                    : (i - 1 + carouselImages.length) % carouselImages.length
                                );
                            }
                            touchStartX.current = null;
                        }}
                        style={{ display: 'inline-block' }}
                    >
                        <img
                            style={{
                                marginTop: 100,
                                width: 600,
                                height: 800,
                                objectFit: 'contain',
                                borderRadius: 40,
                                display: 'block',
                            }}
                            src={carouselImages[carouselIndex]}
                            alt=""
                        />
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 8,
                            marginTop: 12,
                        }}>
                            {carouselImages.map((_, idx) => (
                                <div key={idx} style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: idx === carouselIndex ? '#fff' : 'rgba(255,255,255,0.4)',
                                    transition: 'background 0.3s',
                                }} />
                            ))}
                        </div>
                    </div>

                    <div
                        onClick={() => setShowHome(true)}
                        style={{
                            margin: "20px auto",
                            border: 'none',
                            cursor: 'pointer',
                        }}
                        >
                       <img src={require('./assets/seemenu.png')}  style={{objectFit: 'contain', width:250}}/>
                        </div>
                </div>
            </div>

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}

             {showHome && <HomeScreen  />}
            
        </LayoutContent>
    );
}

export default Index;